(function () {
  var accordionInstances = new WeakMap();

  function initFooterAccordions(root) {
    var scope = root || document;
    var footers = scope.matches && scope.matches('.footer') ? [scope] : scope.querySelectorAll('.footer');

    footers.forEach(function (footer) {
      if (accordionInstances.has(footer)) return;

      var accordions = footer.querySelectorAll('.footer-block__accordion');
      if (!accordions.length) return;

      var mobileQuery = window.matchMedia('(max-width: 749px)');

      function syncFooterAccordions(isMobile) {
        accordions.forEach(function (accordion) {
          accordion.open = !isMobile;
        });
      }

      syncFooterAccordions(mobileQuery.matches);

      function handleMediaChange(event) {
        syncFooterAccordions(event.matches);
      }

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleMediaChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(handleMediaChange);
      }

      accordionInstances.set(footer, function () {
        if (typeof mobileQuery.removeEventListener === 'function') {
          mobileQuery.removeEventListener('change', handleMediaChange);
        } else if (typeof mobileQuery.removeListener === 'function') {
          mobileQuery.removeListener(handleMediaChange);
        }
      });
    });
  }

  function cleanupFooterAccordions(root) {
    var scope = root || document;
    var footers = scope.matches && scope.matches('.footer') ? [scope] : scope.querySelectorAll('.footer');

    footers.forEach(function (footer) {
      var cleanup = accordionInstances.get(footer);
      if (!cleanup) return;
      cleanup();
      accordionInstances.delete(footer);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFooterAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFooterAccordions(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupFooterAccordions(event.target);
  });

  initFooterAccordions(document);
})();
